<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-toast [style]="{marginTop: '80px'}" position="top-left" key="tl"></p-toast>
<p-toast [style]="{marginTop: '80px'}" position="top-center" key="tc"></p-toast>
<p-toast [style]="{marginTop: '80px'}" position="bottom-center" key="bc"></p-toast>
<!-- <p-progressSpinner class="loading-indicator" *ngIf="progressSpinnerDlg"></p-progressSpinner> -->
<p-confirmDialog [style]="{width: '500px'}" header="{{ header }}" acceptLabel="{{ acceptLabel }}" rejectLabel="{{ rejectLabel }}"></p-confirmDialog>
